export const parsedEntitiyData = (data: any) => {
    if (!data || data.length === 0) return [];
    switch (data[0].kind) {
        case 'User':
            return data.map((item: any) => ({
                name: item.metadata.name,
                displayName: item.spec.profile.displayName,
                email: item.spec.profile.email,
                picture: item.spec.profile.picture,
                memberOf: item.spec.memberOf,
            }));
        case 'Group':
            return data.map((item: any) => ({
                name: item.metadata.name,
                title: item.metadata.title,
            }));
        default:
            return data;
    };
};